import {h} from 'preact'
import css from 'minify-css.macro'
import {styles} from '../styles'

export const Spinner: React.FC<SpinnerProps> = ({size = '1em'}) => {
  return (
    <span className={spinner()} style={{fontSize: size}}>
      <span />
      <span />
      <span />
      <span />
    </span>
  )
}

styles.global(css`
  @keyframes spinner {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`)

export const spinner = styles.one(css`
  display: inline-block;
  position: relative;
  width: 1em;
  height: 1em;

  span {
    box-sizing: border-box;
    display: block;
    position: absolute;
    width: 0.67em;
    height: 0.67em;
    margin: 0.0875em;
    border: 0.0875em solid #fff;
    border-radius: 50%;
    animation: spinner 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
    border-color: currentColor transparent transparent transparent;
  }

  span:nth-child(1) {
    animation-delay: -0.45s;
  }

  span:nth-child(2) {
    animation-delay: -0.3s;
  }

  span:nth-child(3) {
    animation-delay: -0.15s;
  }
`)

export interface SpinnerProps extends React.HTMLAttributes<HTMLSpanElement> {
  size?: string | number
}
